import { CloudClient, MockClient, type CommandClient } from '@glyph/core';

/** `VITE_MOCK=1` runs the console against the in-memory MockClient, otherwise the cloud API + /gw/browser.
 *  The session is the API's __Host- cookie; the CSRF header comes from the token `me` / `login` return. */
/** Demo build only: `?as=room_operator&units=cc-02` shows the console as that role (no effect on the real console). */
function mockOptions(): ConstructorParameters<typeof MockClient>[0] {
  const q = typeof location !== 'undefined' ? new URLSearchParams(location.search) : new URLSearchParams();
  const role = q.get('as') as NonNullable<ConstructorParameters<typeof MockClient>[0]>['role'] | null;
  const units = q.get('units')?.split(',').filter(Boolean) ?? [];
  return { mode: 'cloud', ...(role ? { role } : {}), ...(units.length ? { scope: { devices: units, events: [] } } : {}) };
}
export const client: CommandClient = import.meta.env.VITE_MOCK === '1' ? new MockClient(mockOptions()) : new CloudClient();
export const IS_MOCK = import.meta.env.VITE_MOCK === '1';
